import styled from 'styled-components'
import { CartProps } from './Cart'

const VIEWPORT = {
  xs: '0px',
  sm: '576px',
  md: '768px',
  lg: '992px',
  xl: '1200px',
}

export const StickyCartBlock = styled.div`
  padding: 12px 16px;
  @media only screen and (min-width: ${VIEWPORT.lg}) {
    padding-top: 24px;
    padding-left: 24px;
    padding-bottom: 0px;
    position: sticky;
    top: 0;
    margin: 0 auto;
    max-width: 400px;
  }
`

export const CartPrice = styled.div`
  display: inline-block;
  width: 100%;
`

export const ProductTitle = styled.p`
  padding-left: 16px;
  font-size: 1rem;
  max-width: 100%;
  margin: 0px;
`

export const ProductContainer = styled.div`
  display: flex;
  justify-content: space-between;
`

type ProductDescriptionProp = {
  color?
}

export const ProductDescription = styled.div<ProductDescriptionProp>`
  display: flex;
  font-size: 1rem;
  font-family: 'HNforTELUSSA400normal';
  color: ${(props) => (props.color === 'primary' ? '#2C2E30' : '#4b286d')};
  margin-bottom: 18px;
  align-items: flex-start;
  padding-right: 16px;
  @media only screen and (min-width: ${VIEWPORT.lg}) {
    font-family: 'HNforTELUSSA500normal';
  }
`

export const ProductPrice = styled.p`
  color: #2a2c2e;
  font-size: 1rem;
  font-family: 'HNforTELUSSA300normal';
  margin-top: 0;
`

type LinkButtonProp = {
  alignStickySecondaryButtonText?: CartProps['alignStickySecondaryButtonText']
}

export const LinkButton = styled.div<LinkButtonProp>`
  display: flex;
  justify-content: ${(props) =>
    props.alignStickySecondaryButtonText === 'left'
      ? 'flex-start'
      : props.alignStickySecondaryButtonText === 'right'
      ? 'right'
      : 'center'};
  padding-top: 24px;
`

export const PriceContainer = styled.div`
  padding-bottom: 1rem;
`

export const RibbonContainer = styled.div`
  padding-bottom: 8px;
`

export const IconPosition = styled.div`
  display: flex;
  align-items: center;
`

export const CartCallout = styled.div`
  text-align: center;
`

export const ButtonPadding = styled.div`
  min-width: 197px;
  div > a > div,
  div > a > div > div {
    padding: 8px 0px !important;
  }
`
